import React, { Component } from 'react';

import HeaderRouteWrapper from '../components/Elements/Header';
import Footer from '../components/Elements/Footer';
import Routes from '../router';
import { getConfiguration } from '../utils/getConfiguration';
import AppTheme from './Providers/Theme';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { themeDetails, footerContent } from '../theme/theme.ts';


class App extends Component {
  componentDidMount = async (): Promise<void> => {
    await getConfiguration();
    document.title = themeDetails.brandName;
  };

  render(): JSX.Element {
    return (
      <div className="app-wrapper">
        <AppTheme themeName="default">
          <HeaderRouteWrapper />
          <Routes />
          <Footer {...footerContent} />
        </AppTheme>
      </div>
    );
  }
}

export default App;
